export interface ProspectTypeDefinition {
  id: number;
  name: string;
}

export const PROSPECT_TYPES: ProspectTypeDefinition[] = [
  { id: 1, name: "School" },
  { id: 2, name: "District" },
  { id: 3, name: "Organization" },
] as const;
